function SetupStep({ number, title, description, status, action, onAction }) {
  return (
    <div className="flex items-start space-x-4">
      <div className="flex-shrink-0">
        <div className={`w-6 h-6 rounded-full ${
          status === 'completed' ? 'bg-green-100 text-green-600' : 'bg-gray-100'
        } flex items-center justify-center text-sm font-medium`}>
          {status === 'completed' ? '✓' : number}
        </div>
      </div>
      <div className="flex-grow">
        <h3 className="text-base font-medium text-gray-900">{title}</h3>
        <p className="mt-1 text-sm text-gray-500">{description}</p>
      </div>
      <button
        onClick={onAction}
        className="flex-shrink-0 px-3 py-1.5 text-sm font-medium text-indigo-600 hover:text-indigo-900"
      >
        {action}
      </button>
    </div>
  );
}

export default SetupStep;